import { useTheme } from '@mui/material';
import { FC } from 'react';

type Props = {
  initialDurationSeconds: number;
  remainingDurationSeconds: number;
  animationDisabled?: boolean;
};

const circleRadius = 33;
const circleDiameter = circleRadius * 2;
const circleCenterCoordinateXY = 35;
const fullCircleStrokeDashArray = 2 * 3.14 * circleRadius;

const IconProgressCircle: FC<Props> = ({
  initialDurationSeconds,
  remainingDurationSeconds,
  animationDisabled,
}) => {
  const currentCircleStrokeDasharray = `${(
    (remainingDurationSeconds / initialDurationSeconds) *
    fullCircleStrokeDashArray
  ).toFixed(0)} ${fullCircleStrokeDashArray}`;
  const theme = useTheme();
  const strokeColor = theme.palette.primary.main;
  const strokeWidth = theme.spacing(0.5);
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      //ensure animation is left facing
      style={{ transform: 'scaleX(-1)' }}
    >
      <circle
        opacity="0.1"
        cx={circleCenterCoordinateXY}
        cy={circleCenterCoordinateXY}
        r={circleRadius}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <path
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap={remainingDurationSeconds ? 'round' : undefined}
        strokeDasharray={currentCircleStrokeDasharray}
        style={{
          //ensure animation starts from the top of the circle
          transform: 'rotate(90deg)',
          transformOrigin: 'center',
          ...(!animationDisabled && { transition: '0.25s ease all' }),
        }}
        d={`
            M ${circleCenterCoordinateXY}, ${circleCenterCoordinateXY}
            m -${circleRadius}, 0
            a ${circleRadius},${circleRadius} 0 1,0 ${circleDiameter},0
            a ${circleRadius},${circleRadius} 0 1,0 -${circleDiameter},0
          `}
      />
    </svg>
  );
};

export { IconProgressCircle };
